import { render } from "./HomeVinlotteri.vue?vue&type=template&id=65eca915&scoped=true"
import script from "./HomeVinlotteri.vue?vue&type=script&lang=js"
export * from "./HomeVinlotteri.vue?vue&type=script&lang=js"

import "./HomeVinlotteri.vue?vue&type=style&index=0&id=65eca915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eca915"]])

export default __exports__